/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* Cart-only expiry, requested by the merchant: clear Shopify cart after 10 minutes. */
(function () {
  'use strict';
  if (customElements.get('brillova-cart-timer')) return;

  var duration = 10 * 60 * 1000;
  // New key deliberately ignores the former, purely visual product countdown.
  var storageKey = 'brillova:cart-expiry:v2';
  var owner = String(Date.now()) + ':' + Math.random().toString(36).slice(2);
  var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
  var timers = new Set();
  var notices = new Set();
  var memory = null;
  var state = null;
  var interval = null;
  var pending = null;
  var startRequested = false;
  var retryAfter = 0;
  var errorMessage = '';
  var stopped = false;
  var disabledButtons = new Set();

  function readState() {
    try {
      var saved = localStorage.getItem(storageKey);
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      return memory;
    }
  }
  function writeState(next) {
    memory = next;
    state = next;
    try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch (error) {}
  }
  function active(value) {
    return value && (value.status === 'active' || value.status === 'clearing');
  }
  function expired(value) {
    return active(value) && Number.isFinite(value.endTime) && value.endTime <= Date.now();
  }
  function cartId(cart) {
    // Never persist the private key suffix of the Shopify cart token.
    return String(cart.token || '').split('?')[0];
  }
  async function requestCart(path, method) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 10000);
    try {
      var response = await fetch(cartUrl + path, {
        method: method || 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: method === 'POST' ? '{}' : undefined,
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Cart request failed');
      var cart = await response.json();
      if (!Number.isInteger(cart.item_count) || !cart.token) throw new Error('Invalid cart response');
      return cart;
    } finally {
      clearTimeout(timeout);
    }
  }
  function refreshCart() {
    if (window.theme && window.theme.pageType === 'cart') {
      // Prestige's AJAX replacement expects a form even when the cart becomes empty.
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }
  function render() {
    var remaining = active(state) ? Math.max(0, Math.ceil((state.endTime - Date.now()) / 1000)) : 0;
    var blocked = expired(state);
    var message = errorMessage || (blocked ? 'Votre panier a expiré. Suppression des articles en cours…' : 'Attention, votre panier expire dans');
    timers.forEach(function (timer) {
      if (!timer.clock) return;
      timer.hidden = !active(state) && !errorMessage;
      timer.classList.toggle('cart-timer--expired', blocked);
      var formatted = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
      if (timer.clock.textContent !== formatted) timer.clock.textContent = formatted;
      if (timer.label.textContent !== message) timer.label.textContent = message;
      var minute = Math.ceil(remaining / 60);
      var announcement = errorMessage || (blocked ? message : 'Attention, votre panier expire dans ' + minute + (minute === 1 ? ' minute.' : ' minutes.'));
      if (timer.visible && timer.announcement.textContent !== announcement) timer.announcement.textContent = announcement;
    });
    notices.forEach(function (notice) { notice.hidden = !(state && state.status === 'expired'); });
    document.querySelectorAll('.Cart [name="checkout"]').forEach(function (button) {
      if (blocked && !button.disabled) { button.disabled = true; disabledButtons.add(button); }
    });
    if (!blocked) {
      disabledButtons.forEach(function (button) { button.disabled = false; });
      disabledButtons.clear();
    }
  }
  function stopInterval() {
    if (interval !== null) clearInterval(interval);
    interval = null;
  }
  function schedule() {
    stopInterval();
    if (!stopped && active(state) && timers.size) {
      interval = setInterval(function () {
        state = readState() || state;
        render();
        if (expired(state) && Date.now() >= retryAfter) syncCart(false);
      }, 1000);
    }
  }
  async function reconcile(allowStart) {
    var cart = await requestCart('.js');
    var saved = readState();
    var id = cartId(cart);
    if (cart.item_count === 0) {
      var wasExpired = saved && saved.cartId === id && (expired(saved) || saved.status === 'expired');
      writeState({ cartId: id, status: wasExpired ? 'expired' : 'empty', endTime: 0 });
      if (timers.size) refreshCart();
      return;
    }
    if (!saved || saved.cartId !== id || !active(saved) || !Number.isFinite(saved.endTime) || saved.endTime > Date.now() + duration) {
      if (!allowStart && !startRequested) { state = null; return; }
      saved = { cartId: id, status: 'active', endTime: Date.now() + duration };
      writeState(saved);
    } else {
      state = saved;
    }
    if (!expired(saved)) return;
    // Lease is a fallback for browsers without Web Locks. Never send a second
    // clear while another tab has a recent operation in flight.
    if (saved.status === 'clearing' && saved.owner !== owner && saved.leaseUntil > Date.now()) return;
    writeState(Object.assign({}, saved, { status: 'clearing', owner: owner, leaseUntil: Date.now() + 15000 }));
    render();
    var cleared = await requestCart('/clear.js', 'POST');
    if (cleared.item_count !== 0) throw new Error('Cart was not cleared');
    writeState({ cartId: cartId(cleared), status: 'expired', endTime: 0 });
    refreshCart();
  }
  function syncCart(allowStart) {
    startRequested = startRequested || allowStart;
    if (pending) return pending;
    pending = Promise.resolve().then(function () {
      if (navigator.locks && navigator.locks.request) {
        return navigator.locks.request(storageKey, function () { return reconcile(allowStart); });
      }
      return reconcile(allowStart);
    }).then(function () {
      errorMessage = '';
      retryAfter = 0;
    }).catch(function () {
      // Keep the expired deadline and retry after checking the actual cart again.
      // A lost response must not be mistaken for proof that removal succeeded.
      errorMessage = expired(state) ? 'Panier expiré. Connexion nécessaire pour retirer les articles.' : 'Vérification du panier indisponible. Réessayez dans un instant.';
      retryAfter = Date.now() + 5000;
    }).finally(function () {
      pending = null;
      startRequested = false;
      render();
      schedule();
    });
    return pending;
  }

  class CartTimer extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.clock = this.querySelector('[data-cart-timer-clock]');
      this.label = this.querySelector('[data-cart-timer-label]');
      this.announcement = this.querySelector('[data-cart-timer-announcement]');
      if (!this.clock || !this.label || !this.announcement) return;
      timers.add(this);
      this.visible = false;
      this.hidden = false;
      var drawer = this.closest('.Drawer');
      var inViewport = false;
      var observer;
      var drawerObserver;
      var show = () => {
        this.visible = inViewport && (!drawer || drawer.getAttribute('aria-hidden') !== 'true');
        if (this.visible) syncCart(true);
      };
      if (drawer) {
        drawerObserver = new MutationObserver(show);
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
      if (typeof IntersectionObserver === 'function') {
        observer = new IntersectionObserver(entries => { inViewport = entries[0].isIntersecting; show(); });
        observer.observe(this);
      } else { inViewport = true; show(); }
      this.cleanup = () => {
        if (observer) observer.disconnect();
        if (drawerObserver) drawerObserver.disconnect();
        timers.delete(this);
        schedule();
      };
      state = readState();
      if (active(state)) syncCart(false);
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
      this.cleanup = null;
    }
  }
  class ExpiryNotice extends HTMLElement {
    connectedCallback() {
      notices.add(this);
      state = readState();
      render();
      // Confirm empty state and cancel any deadline after manual removal.
      syncCart(false);
    }
    disconnectedCallback() { notices.delete(this); }
  }

  // Expired carts cannot proceed to checkout or receive a late add while clearing.
  function guard(event) {
    var target = event.target.closest && event.target.closest('form.Cart, form.ProductForm, [data-action="add-to-cart"]');
    state = readState() || state;
    if (target && expired(state)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      render();
      syncCart(false);
    }
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[name="checkout"], [data-action="add-to-cart"]')) guard(event);
  }, true);
  window.addEventListener('storage', function (event) {
    if (event.key !== storageKey) return;
    var previous = state;
    state = readState();
    render();
    schedule();
    if (state && state.status === 'expired' && (!previous || previous.status !== 'expired')) refreshCart();
  });
  window.addEventListener('pagehide', function () { stopped = true; stopInterval(); });
  window.addEventListener('pageshow', function () {
    stopped = false;
    if (timers.size || notices.size) syncCart(Array.from(timers).some(timer => timer.visible));
  });
  window.addEventListener('online', function () { if (timers.size) syncCart(true); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && timers.size) syncCart(Array.from(timers).some(timer => timer.visible));
  });
  customElements.define('brillova-cart-expiry-notice', ExpiryNotice);
  customElements.define('brillova-cart-timer', CartTimer);
})();

/* Connect Amose offers to Prestige's existing cart drawer. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (root.hasAttribute('data-brillova-amose-cart-bridge')) return;
  root.setAttribute('data-brillova-amose-cart-bridge', '');

  function connectDrawer() {
    if (!document.getElementById('sidebar-cart')) return;
    // Amose uses this attribute to find a theme's existing drawer opener.
    document.querySelectorAll('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]').forEach(function (button) {
      button.setAttribute('data-cart-drawer-toggle', '');
    });
  }

  // Amose dispatches on document; Prestige listens on documentElement.
  // Ignore bubbling native refreshes so the relay never calls itself.
  document.addEventListener('cart:refresh', function (event) {
    if (event.target !== document || !document.getElementById('sidebar-cart')) return;
    root.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: event.detail
    }));
  });

  connectDrawer();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectDrawer, { once: true });
  }
  document.addEventListener('shopify:section:load', connectDrawer);
})();
